export const SUPPORTS_OBJECT_DEFINE_PROPERTIES = "defineProperties" in Object;
